/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

/**
 * One card of a Speakeasy-built dashboard: a widget's question and drawing, as a saved widget stores them, with where it sits on the 12-column grid. It is not a saved widget; duplicating the dashboard makes one of it.
 */
export type BuiltInCard = {
  /**
   * The catalog dataset the card asks
   */
  dataset: string;
  /**
   * What the card shows, when there is more to say
   */
  description?: string | undefined;
  /**
   * Height in rows
   */
  h: number;
  /**
   * What the card is called
   */
  name: string;
  /**
   * The question: window, grain, dimensions, measures, filters, order and limit, in the shape a saved widget stores.
   */
  query: { [k: string]: any };
  /**
   * How the question is drawn: a chart type and its options.
   */
  visualization: { [k: string]: any };
  /**
   * Width in columns
   */
  w: number;
  /**
   * Column the card starts at, from 0
   */
  x: number;
  /**
   * Row the card starts at, from 0
   */
  y: number;
};

/** @internal */
export const BuiltInCard$inboundSchema: z.ZodMiniType<BuiltInCard, unknown> = z
  .object({
    dataset: z.string(),
    description: z.optional(z.string()),
    h: z.int(),
    name: z.string(),
    query: z.record(z.string(), z.any()),
    visualization: z.record(z.string(), z.any()),
    w: z.int(),
    x: z.int(),
    y: z.int(),
  });

export function builtInCardFromJSON(
  jsonString: string,
): SafeParseResult<BuiltInCard, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => BuiltInCard$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'BuiltInCard' from JSON`,
  );
}
